module.exports = __webpack_public_path__ + "img/auth_background.e48c616e.svg";